import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createSvgIcon } from '@mui/material/utils';
// From Material Design Icons: https://pictogrammers.com/library/mdi/
// MDI Icon Name: 'information-slab-circle'
export const InfoIcon = createSvgIcon(_jsx("path", { fill: 'currentColor', d: 'M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22M11 7H13V9H11V7M14 17H10V15H11V13H10V11H13V15H14V17Z' }), 'Info');
